module.exports = __webpack_public_path__ + "img/yesOrNoEle.09f47bd8.svg";